var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-061aa989&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./product-details.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./product-details.vue")
__vue_template__ = require("!!vue-html-loader!../../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-061aa989!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./product-details.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./src/components/layout/product-details.vue
// module id = 211
// module chunks = 0